import { ArrowBarLeft } from "react-bootstrap-icons";

const AccessDenied = () => (
    <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="text-center">
            <h1 className="display-4">403</h1>
            <h2 className="text-muted mb-4">Access Denied</h2>
            <p className="lead">You do not have permission to access this page.</p>
            <a onClick={() => window.history.back()} className="btn btn-primary mt-3 me-2"><ArrowBarLeft /> Back</a>
            {/* <a href="/login" className="btn btn-primary mt-3">Go to login page</a> */}
        </div>
    </div>
);

export default AccessDenied;
